var jrDispatcher = require("../dispatchers/jumprunDispatcher");
var api = require("../api/jumprunApiClient");

var ac = {

	selectYear: function(year) {
		jrDispatcher.handleCommonAction({
			type: "yearSelect",
			data: year
		});

		/*api.toplist(year).then(function(toplist) {
			jrDispatcher.handleToplistAction({
				type: "loaded",
				data: toplist
			});
		});*/
	}
};

module.exports = ac;
